import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fcqyym5uay: FaireBrandEntity = {
  token: "b_fcqyym5uay",
  type: "brand",
  name: "Nat Ellis Illustration",
  avatarUrl:
    "https://cdn.faire.com/fastly/64a0943d09eea9aaed6405acf4233b4fab08b15578d86e0edfdfebb679a3b3d1.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c45c783029c79abf36f6b07a48ca42fc7abaeb6d11f966feb64de49ee3df382e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/64a0943d09eea9aaed6405acf4233b4fab08b15578d86e0edfdfebb679a3b3d1.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c45c783029c79abf36f6b07a48ca42fc7abaeb6d11f966feb64de49ee3df382e.jpeg",
  location: "Stafford, GBR",
  minimumOrderDollars: 115,
  rating: 5,
  reviewCount: 6,
  isTopShop: true,
  isInsider: false,
  description:
    "Nat launched her shop in 2019 selling colourful and contemporary accessories, stationery and prints illustrated with her fun and whimsical designs.   Her collections have evolved over the years; however, the core values of this business have remained consistent; Nat strives to create products that not only look great but are also as eco- friendly and as sustainable as possible.  Greetings cards, prints and tote bags are printed on recycled materials, packaging is recyclable and cellophane wraps are all compostable.   Additionally, products are manufactured by independent British companies with great credentials.\n\nAll photographs ©@girl_behindthelens /  www.girlbehindthelens.co.uk",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:14.652Z",
    importedBy: "entity-db-cli",
  },
};
